module.exports = __webpack_public_path__ + "static/media/office6.32cf1e95.jpg";